export default __webpack_public_path__ + "static/media/a2censo-user-data.c9fe86e9.png";